import React from 'react';
import { ProfileViewEntity } from '@interpals/api-web';

import Slider from 'components/ui/Slider';
import UserAvatarLink from 'components/UserAvatarLink';

import css from './ViewsNotifications.module.scss';

interface Props {
    views: ProfileViewEntity[];
}

const ViewsNotifications: React.FC<Props> = ({ views }) => {
    const number = views.length % 7 === 0 ? Math.floor(views.length / 7) : 1 + Math.floor(views.length / 7);
    const pages = Array.from({ length: number }, (_, i) => i);

    return (
        views && (
            <Slider totalItems={number} buttonsOffsetTop="calc(50% - 38px)">
                {pages.map((page) => (
                    <Slider.Item key={page}>
                        <div className={css.row}>
                            {views.slice(page * 7, 7 + 7 * page).map((view, i) => (
                                <UserAvatarLink
                                    size="M"
                                    key={i}
                                    user={view.user}
                                    indicatorColor={view.new ? 'blue' : undefined}
                                />
                            ))}
                        </div>
                    </Slider.Item>
                ))}
            </Slider>
        )
    );
};

export default React.memo(ViewsNotifications);
